import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import {
  pagingSync
} from "app/services/ServiceRequestItemService";
import { removeTreament } from "app/services/SyncCRMService";

export default class TreatmentVoidedAsyncStore {
  searchTreatmentListAll = {
    ...new SearchObject(),
    fromLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    toLastDateSync: new Date(),
    departmentId: null,
    isSyncedToCRM: false,
    voided: true
  };
  pageTreatmentListAll = new PageResponse();
  selectTrementAsync = [];
  resetSelectedRows = false;

  constructor() {
    makeAutoObservable(this);
  }

  pagingTreatmentListAll = async () => {
    const { departmentId, performerId, roomId, healthCareSvId, ...ortherData } =
      this.searchTreatmentListAll;
    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    }

    if (performerId) {
      ortherData.performerId = performerId?.id;
    }

    if (roomId) {
      ortherData.roomId = roomId?.id;
    }
    if (healthCareSvId) {
      ortherData.healthCareSvId = healthCareSvId?.id;
    }
    return await pagingSync({ ...ortherData, voided: true })
      .then(({ data }) => {
        this.pageTreatmentListAll = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu điều trị có lỗi");
      });
  };

  handleChangeFormSearch = (searchTreatmentListAll) => {
    this.searchTreatmentListAll = {
      ...this.searchTreatmentListAll,
      ...searchTreatmentListAll,
    };
    this.pagingTreatmentListAll();
  };

  setSelectTreamentAsync = (list) => {
    this.selectTrementAsync = list;
  };

  removeListTreamentAsync = async () => {
    const visitIds = this.selectTrementAsync?.map((el) => el?.id) || [];
    if (visitIds.length === 0) {
      toast.warning("Chưa chọn điều trị nào để đồng bộ");
      return [];
    }
    this.resetSelectedRows = !this.resetSelectedRows;
    try {
      const { data } = await removeTreament(visitIds);
      this.resetSelectedRows = !this.resetSelectedRows;
      this.selectCheckInAsync = [];

      if (Array.isArray(data)) {
        const successCount = data.length;
        const total = visitIds.length;

        if (successCount === total) {
          toast.success(`Đồng bộ điều trị thành công: ${successCount}/${total} bản ghi`);
        } else if (successCount > 0) {
          toast.warning(`Đồng bộ điều trị thành công một phần: ${successCount}/${total} bản ghi`);
        } else {
          toast.error("Đồng bộ điều trị thất bại");
        }

        this.pagingCheckIn();
        return data;
      } else {
        toast.error("Dữ liệu trả về từ API không hợp lệ");
        return [];
      }
    } catch (error) {
      console.error(error);
      this.resetSelectedRows = !this.resetSelectedRows;
      this.selectCheckInAsync = [];
      toast.error("Đồng bộ điều trị có lỗi");
      return [];
    }
  };

  resetStore = () => {
    this.searchTreatmentListAll = {
      ...new SearchObject(),
      fromLastDateSync: new Date(),
      toLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    };
    this.pageTreatmentListAll = new PageResponse();
  };

}
